import { Flex } from '@chakra-ui/react'
import React from 'react'

type PageWrapperProps = {
  children: React.ReactNode
}

const PageWrapper: React.FC<PageWrapperProps> = ({ children }) => {
  return (
    <Flex
      color='black'
      w='100%'
      minH='80vh'
      alignItems='center'
      padding={{ base: 8, lg: 24 }}
      paddingTop={{ base: 12, lg: 12 }}
      direction='column'
    >
      {children}
    </Flex>
  )
}
export default PageWrapper
